module.exports = __webpack_public_path__ + "static/media/BMI.0249d358.jpg";